import { getOpenedModalsData } from "selectors/ui";
import { useDispatch, useSelector } from "react-redux";
import AddBusinessWindow from "lib/windows/AddBusinessWindow";
import AddReasonWindow from "lib/windows/AddReasonWindow";
import AddTagsWindow from "lib/windows/AddTagsWindow";
import LinkContactWindow from "lib/windows/LinkContactWindow";
import ModalNames from "const/ModalNames";
import React, { useCallback } from "react";
import SetupBackupWindow from "lib/windows/SetupBackupWindow";
import UiActions from "actions/UiActions";

const {
  LINK_CONTACT_WINDOW,
  ADD_TAGS_WINDOW,
  ADD_REASON_WINDOW,
  ADD_BUSINESS_WINDOW,
  SETUP_BACKUP_WINDOW
} = ModalNames;

const getModalComponent = (modalName) => {
  switch (modalName) {
    case LINK_CONTACT_WINDOW:
      return LinkContactWindow;
    case ADD_TAGS_WINDOW:
      return AddTagsWindow;
    case ADD_REASON_WINDOW:
      return AddReasonWindow;
    case ADD_BUSINESS_WINDOW:
      return AddBusinessWindow;
    case SETUP_BACKUP_WINDOW:
      return SetupBackupWindow;

    default:
      return null;
  }
};

const ModalsContainer = () => {
  const dispatch = useDispatch();

  const openedModalsData = useSelector(getOpenedModalsData);

  const handleModalClose = useCallback((result) => {
    dispatch(UiActions.hideCustomModal(result));
  }, [dispatch]);

  return openedModalsData.map(({ modalName, ...restData }, index) => {
    const ModalComponent = getModalComponent(modalName);

    return ModalComponent
      ? <ModalComponent
        key={modalName}
        disabled={(index + 1) < openedModalsData.length}
        noOverlay={!!index}
        {...restData}
        onClose={handleModalClose} />
      : null;
  });
};

export default React.memo(ModalsContainer);
